import Vue from 'vue';
import { getMemberList, getCanTakeList, getMemberProgramRecord, removeNewMemberTag, applyProgram} 
from '../../../services/personnelService/trialPlanService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  memberList: [],
  availableList: [],
  pagination: {
    current_page: 0,
    per_page: 20
  },
  programRecord: [],
  isBackNewMember: false,
};

// getters
const getters = {};

// actions
const actions = {
  // 取得參與試用計畫的會員列表
  async getMemberListHandler({ commit }, paginationInfo) {
    // paginationInfo.sort_by = 'note_name';
    // paginationInfo.sort_direction = 'asc';
    const data = await getMemberList(paginationInfo);
    commit('setMemberList', data);
  },
  // 取得符合寄出條件的會員列表
  async getAvailableListHandler({ commit }, paginationInfo) {
    const data = await getCanTakeList(paginationInfo);
    commit('setAvailableList', data);
  },
  // 取得會員活動狀態
  async getMemberRecordHandler({ commit }, memebrId) {
    const data = await getMemberProgramRecord(memebrId);
    commit('setProgramRecord', data);
    commit('setIsBackNewMember', data.data.is_back_new_member);
  },
  //取消新會員的註記
  async removeNewTagHandler({ }, memberId){
    await removeNewMemberTag(memberId);
  },
  //申請計畫
  async applyProgramHandler({ }, info){
    await applyProgram(info);
  }
};

// mutations
const mutations = {
  setMemberList(state, data) {
    Vue.set(state, 'memberList', data.data.list);
    Vue.set(state, 'pagination', data.pagination);
  },
  setAvailableList(state, data) {
    Vue.set(state, 'availableList', data.data.list);
    Vue.set(state, 'pagination', data.pagination);
  },
  setProgramRecord(state, data) {
    Vue.set(state, 'programRecord', data.data.list);
  },
  setIsBackNewMember(state, isBackNewMember) {
    state.isBackNewMember = isBackNewMember;
  },
  resetHandler(state) {
    Vue.set(state, 'memberList', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 20
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
